import isPositiveConsentTemplate from './isPositiveConsentTemplate';

const documentTemplates = ['DOCUMENT_SIGN', 'DOCUMENT_VIEW'];

// Blocks whose formData carries a document the client has to open.
export default function isDocumentTemplate(template: string) {
  return (
    documentTemplates.includes(template) || isPositiveConsentTemplate(template)
  );
}
